// Sharetribe disconnect: the top notification bar used to come entirely
// from Sharetribe's hosted notificationBar.json config -- with that gone,
// getDataNotificationBar.js falls back to these local values instead of
// the empty defaults it previously used to avoid crashing. Same
// hosted-value-first, local-default pattern as configBranding.js.

export const backgroundColor = '#d9f2df';
export const textColor = '#1e6626';
export const contentTitle =
  'Coaches make 100% of what they earn on our website and 0% commission fees for all coaches!';
export const contentCallToAction = 'Sign up now!';
export const hrefCallToAction = '/signup';
